import Http from "../utils/Http";

export const LOGIN_LINK_PLATFORM_PORTAL = 1;
export const LOGIN_LINK_BINDING_KEY = "login_link_binding";
export const LOGIN_LINK_PENDING_KEY = "login_link_pending";
export const LOGIN_LINK_TTL_MS = 20 * 60 * 1000;
export const LOGIN_LINK_STATUS_PENDING = "pending";
export const LOGIN_LINK_STATUS_OPENED_ELSEWHERE = "opened_elsewhere";
export const LOGIN_LINK_STATUS_EXPIRED = "expired";

const toHex = bytes =>
  Array.from(bytes)
    .map(byte => byte.toString(16).padStart(2, "0"))
    .join("");

export function readBindingSecret() {
  try {
    return localStorage.getItem(LOGIN_LINK_BINDING_KEY);
  } catch (e) {
    return null;
  }
}

function bindingSecret() {
  const saved = readBindingSecret();
  if (saved) {
    return saved;
  }
  const secret = toHex(window.crypto.getRandomValues(new Uint8Array(32)));
  localStorage.setItem(LOGIN_LINK_BINDING_KEY, secret);
  return secret;
}

export function hashBindingSecret(secret) {
  try {
    return window.crypto.subtle
      .digest("SHA-256", new TextEncoder().encode(secret))
      .then(digest => toHex(new Uint8Array(digest)))
      .catch(() => null);
  } catch (e) {
    return Promise.resolve(null);
  }
}

export function bindingHash() {
  try {
    return hashBindingSecret(bindingSecret());
  } catch (e) {
    return Promise.resolve(null);
  }
}

export function readPending() {
  try {
    const pending = JSON.parse(localStorage.getItem(LOGIN_LINK_PENDING_KEY));
    return pending &&
      typeof pending.email === "string" &&
      typeof pending.sent_at === "number"
      ? pending
      : null;
  } catch (e) {
    return null;
  }
}

export function isPendingFresh(pending) {
  return !!pending && Date.now() - pending.sent_at < LOGIN_LINK_TTL_MS;
}

export function readFreshPending() {
  const pending = readPending();
  return isPendingFresh(pending) ? pending : null;
}

export function savePending(pending) {
  try {
    localStorage.setItem(LOGIN_LINK_PENDING_KEY, JSON.stringify(pending));
    return true;
  } catch (e) {
    return false;
  }
}

export function removePending() {
  try {
    localStorage.removeItem(LOGIN_LINK_PENDING_KEY);
    return true;
  } catch (e) {
    return false;
  }
}

const post = (path, input) => () =>
  new Promise((resolve, reject) => {
    Http.post(path, input)
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });

export function sendLoginLink(input) {
  return post("login-link/email", input);
}

export function consumeLoginLink(input) {
  return post("login-link/consume", input);
}

export function loginLinkStatus(input) {
  return post("login-link/status", input);
}

export function consumeLoginLinkCode(input) {
  return post("login-link/consume-code", input);
}
